module.exports = __webpack_public_path__ + "static/story4-02-3815x1355-2ac26920bcd2c6266925d5338c4ce879.jpg";